// AdminReports.js
import React, { useState } from 'react';
import api from '../../services/api';
import { Download, FileText, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function AdminReports() {
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(null);

  const downloadReport = async (format) => {
    setLoading(format);
    try {
      const response = await api.get('/reports/monthly', {
        params: { month, year, format },
        responseType: 'blob'
      });
      const ext = format === 'excel' ? 'xlsx' : 'pdf';
      const url = URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `rapport_presence_${month}_${year}.${ext}`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Rapport téléchargé !');
    } catch (err) {
      toast.error('Erreur génération rapport');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Rapports de Présence</h1>
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
        <h2 className="font-semibold text-gray-700 mb-4">Rapport mensuel</h2>
        <div className="flex gap-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1.5">Mois</label>
            <select value={month} onChange={e => setMonth(e.target.value)} className="px-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
              {Array.from({length: 12}, (_, i) => (
                <option key={i+1} value={i+1}>{new Date(2024, i).toLocaleString('fr', {month: 'long'})}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1.5">Année</label>
            <select value={year} onChange={e => setYear(e.target.value)} className="px-4 py-2.5 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none">
              {[2024, 2025, 2026].map(y => <option key={y}>{y}</option>)}
            </select>
          </div>
        </div>
        <div className="flex gap-4">
          <button onClick={() => downloadReport('excel')} disabled={!!loading}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 disabled:opacity-50 text-white px-5 py-3 rounded-xl font-medium transition">
            {loading === 'excel' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
            Télécharger Excel
          </button>
          <button onClick={() => downloadReport('pdf')} disabled={!!loading}
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white px-5 py-3 rounded-xl font-medium transition">
            {loading === 'pdf' ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileText className="w-4 h-4" />}
            Télécharger PDF
          </button>
        </div>
      </div>
    </div>
  );
}
